/** Langage Markdown des cartes pour CodeMirror (mêmes extensions que l'affichage). */
import { markdown } from '@codemirror/lang-markdown';
import { EXTENSIONS_CARTES, EXTENSIONS_SANS_TROUS } from '../../contenu/syntaxe';

/** Les trous ne sont reconnus que dans une carte de texte à trous. */
export function langageCartes(avecTrous: boolean) {
  return markdown({
    extensions: avecTrous ? EXTENSIONS_CARTES : EXTENSIONS_SANS_TROUS,
    addKeymap: false,
    completeHTMLTags: false,
  });
}
